import React from "react";
import "./Home.scss";
import {
  androidButton,
  androidLogo,
  appleLogo,
  bookingImg,
  dataimg,
  dataimg2,
  dataimg3,
  dataimg4,
  iosButton,
  painImage,
  QRcodeImg,
  wellnessImg1,
  wellnessImg2,
  wellnessImg3,
  wellnessImg4,
  wellnessImgUpdate,
} from "../../assets/images";
import { elementsIcon, home_bg1, home_bg2 } from "../../assets/icons";
import { Link } from "react-router-dom";
import { RxArrowTopRight } from "react-icons/rx";
import KnowledgeCenter from "./section/KnowledgeCenter";
import ClientsReview from "./section/ClientsReview";
import FAQ from "./section/FAQ";
import ContactUs from "./section/ContactUs";
import Doctor from "./section/Doctor";
import DoctorCategory from "../doctor/DoctorCategory";
import Founder from "./section/Founder";
import { Helmet } from "react-helmet";
const Home = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "MedicalOrganization",
        "@id": "https://holypills.in/#organization",
        name: "Holypills",
        url: "https://holypills.in/",
        logo: "https://holypills.in/blog/wp-content/uploads/2025/07/logo-holypills.png",
        sameAs: [
          "https://www.facebook.com/holypillscare/",
          "https://www.x.com/holypillscare",
          "https://www.instagram.com/holypillscare",
          "https://www.youtube.com/@Holypillscare",
          "https://www.linkedin.com/company/holypillscare/",
          "https://holypills.in/",
        ],
        department: [
          {
            "@type": "MedicalBusiness",
            "@id": "https://holypills.in/#noida-location",
            name: "Holypills Noida",
            url: "https://holypills.in/",
            telephone: "+91 9999887833",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "UGF-4, P6, Ocean Complex Sector - 18, Opposite GIP Mall",
              addressLocality: "Noida",
              addressRegion: "UP",
              postalCode: "201301",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "28.582598219375473",
              longitude: "77.32425561144417",
            },
          },
          {
            "@type": "MedicalBusiness",
            "@id": "https://holypills.in/#delhi-location",
            name: "Holypills Delhi",
            url: "https://holypills.in/",
            telephone: "+91 9990709586",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Connaught Place 4 - S, DCM Building, Barakhamba Road",
              addressLocality: "Delhi",
              addressRegion: "Delhi",
              postalCode: "110001",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "28.63002133140495",
              longitude: "77.22458600938388",
            },
          },
        ],
      },
      {
        "@type": "Physician",
        "@id": "https://holypills.in/#dr-ila-kathuria",
        name: "Dr. Ila Kathuria",
        gender: "Female",
        image:
          "https://holypills.in/blog/wp-content/uploads/2025/11/Dr-Ila-.webp",
        url: "https://holypills.in/doctors-details/dr-ila-kathuria",
        worksFor: { "@id": "https://holypills.in/#organization" },
        medicalSpecialty: [
          "Homeopathy",
          "PCOS treatment",
          "Endometriosis Treatment",
          "Menopause Treatment",
          "Postpartum Treatment",
          "Holistic Healing",
        ],
        sameAs: [
          "https://www.facebook.com/drila.kathuria/",
          "https://x.com/DrKathuria283",
          "https://www.linkedin.com/in/ila-kathuria-710941370/",
          "https://holypills.in/doctors-details/dr-ila-kathuria",
        ],
      },
    ],
  };

  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",

        name: "What is the menstrual cycle?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "The menstrual cycle is a natural monthly process in women where the body prepares for pregnancy. It involves hormonal changes that regulate ovulation and menstruation.",
        },
      },
      {
        "@type": "Question",

        name: "What are the different phases of the menstrual cycle?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "The cycle has four phases: menstrual, follicular, ovulation, and luteal. Each phase plays an important role in fertility and hormone balance. Holypills provides guidance and treatment to help manage symptoms in every phase naturally.",
        },
      },
      {
        "@type": "Question",

        name: "How can I predict my next period date?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "Tracking your cycle length and symptoms helps predict your next period. You can use our AI-powered app or a calendar for accuracy. Our application uses advanced technology to understand your cycle better and maintain hormonal balance.",
        },
      },
      {
        "@type": "Question",

        name: "Can I use multiple trackers together?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "You can use multiple trackers together to start a combined healing journey. Using our all-in-one app ensures seamless, accurate tracking without confusion and provides personalized insights to optimize your treatment plan effectively.",
        },
      },
      {
        "@type": "Question",

        name: "Is my data private?",

        acceptedAnswer: {
          "@type": "Answer",

          text: "Protecting your privacy is a top priority. We ensure all your health and personal information is secure and confidential, complying with the highest privacy standards.",
        },
      },
    ],
  };
  return (
    <>
      <Helmet defer={false}>
        <title>Online Homeopathy Consultation for Women’s Health</title>
        <meta
          name="description"
          content="Holypills offers expert homeopathy care & AI-driven tracking for PCOS, Endometriosis, Menopause & Postpartum recovery."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link href="https://holypills.in/" rel="canonical"></link>
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Online Homeopathy Consultation for Women’s Health"
        />
        <meta
          property="og:description"
          content="Holypills offers expert homeopathy care & AI-driven tracking for PCOS, Endometriosis, Menopause & Postpartum recovery."
        />

        <meta property="og:url" content="https://holypills.in/" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Online Homeopathy Consultation for Women’s Health"
        />
        <meta
          name="twitter:description"
          content="Holypills offers expert homeopathy care & AI-driven tracking for PCOS, Endometriosis, Menopause & Postpartum recovery."
        />
        <meta name="twitter:url" content="https://holypills.in/"></meta>
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">{JSON.stringify(faqData)}</script>
      </Helmet>

      <div className="home_page wrapper_pcos_page" id="home">
        <div className="women_wellness spacing">
          <div className="container">
            <div className="page_title">
              <div className="wrap_flex">
                <img src={home_bg2} alt="banner-image" />
                <div className="inner_width">
                  <h1>
                    AI-Powered Women’s Health <br /> Tracker App
                  </h1>
                  <p>
                    AI-Powered Women’s Health Tracker for PCOS, Menopause,
                    Endometriosis & Postpartum cure
                  </p>
                </div>
                <img src={home_bg1} alt="background-image" />
              </div>
              <div className="btm-content">
                <div className="download-icon">
                  <span>
                    Download <br />
                    Now!
                  </span>
                  <div className="download_button">
                    <a
                      href="https://apps.apple.com/us/app/holypills/id6752483362"
                      target="_blank"
                    >
                      <img src={appleLogo} alt="ios-icon" />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.holypills"
                      target="_blank"
                    >
                      <img src={androidLogo} alt="android-icon" />
                    </a>
                  </div>
                </div>
                <div className="btn-box">
                  <a href="https://www.youtube.com/watch?v=PBk7rERvUzg" target="_blank" className="button blank">
                    Watch How It Works
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="card_wrap">
            <div className="item">
              <img
                className="main_img"
                src={wellnessImg1}
                alt="wellness-image"
              />
              <div className="wrap_data">
                <span className="tag">PCOS Tracker</span>
                <span className="txt">
                  Track your symptoms, cycles, and lifestyle patterns with smart
                  insights to manage PCOS more effectively.
                </span>
              </div>
              <figure>
                <img src={dataimg2} alt="icon" />
              </figure>
            </div>
            <div className="item">
              <img
                className="main_img"
                src={wellnessImg2}
                alt="wellness-image"
              />
              <div className="wrap_data">
                <span className="tag">Endometriosis Tracker</span>
                <span className="txt">
                  Log pain levels, flare-ups, and triggers to better understand
                  your body and manage endometriosis with data-backed support.
                </span>
              </div>
              <figure>
                <img src={painImage} alt="icon" />
              </figure>
            </div>
            <div className="item">
              <img
                className="main_img"
                src={wellnessImg3}
                alt="wellness-image"
              />
              <div className="wrap_data">
                <span className="tag">Menopause Tracker</span>
                <span className="txt">
                  Navigate hormonal changes confidently with personalized
                  tracking and real-time insights designed for your menopause
                  journey.
                </span>
              </div>
              <figure>
                <img src={wellnessImgUpdate} alt="icon" />
              </figure>
            </div>
            <div className="item">
              <img
                className="main_img"
                src={wellnessImg4}
                alt="wellness-image"
              />
              <div className="wrap_data">
                <span className="tag">Postpartum Tracker</span>
                <span className="txt">
                  Support your recovery and emotional well-being after birth
                  with intelligent tracking tailored to your postpartum health.
                </span>
              </div>
              <figure>
                <img src={dataimg3} alt="icon" />
              </figure>
            </div>
          </div>
        </div>
        <div className="Features spacing">
          <div className="container">
            <div className="page_title">
              <h2>Smart Features Built for Women’s Health</h2>
              <p>
                Explore smart Women’s Health Tracker, AI-driven features built
                to support every phase of your health journey. From cycle
                tracking to symptom insights, everything is designed just for
                you.
              </p>
            </div>

            <div className="card_wrap">
              <div className="item">
                <span>01</span>
                <h3>
                  Track Your Hormonal <br /> Health
                </h3>
                <p>
                  Monitor your hormones with precision. HolyPills helps you
                  track symptoms, cycles, and mood shifts across life stages—so
                  you understand your body better and act with confidence.
                </p>
              </div>
              <div className="item">
                <span>02</span>
                <h3>
                  AI-Based Health <br /> Suggestions
                </h3>
                <p>
                  Get personalized, data-backed health tips powered by AI.
                  HolyPills analyzes your patterns to offer smart, timely
                  suggestions that support your daily well-being and long-term
                  goals.
                </p>
              </div>
              <div className="item">
                <span>03</span>
                <h3>
                  Book Online <br />
                  Consultations
                </h3>
                <p>
                  Connect with trusted women’s health specialists from wherever
                  you are. HolyPills lets you book secure online consultations
                  for expert advice, on your schedule.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* founder  */}

        <Founder />

        {/* -----Doctor-Category------- */}
        <DoctorCategory />

        {/* Knowledge Center */}
        <KnowledgeCenter />

        <ClientsReview />

        {/* FAQ */}
        <FAQ type={"home"} />

        {/* Contact us */}
        <ContactUs />

        {/* Book Your Consultation. */}
        <div className=" container spacing">
          <div className="booking_content">
            <div className="container_flex_wrap">
              <div className="image_wrap">
                <img src={bookingImg} alt="booking-image" />
              </div>
              <div className="content">
                <h4>
                  Built For Women, Powered By AI{" "}
                  <img src={QRcodeImg} alt="scanner-image" />
                </h4>
                <h6>Download Our App for Free</h6>
                <p>
                  Take control of your health with smart health tracking
                  features and expert guidance.
                </p>

                <div className="button_wrap button_left">
                  <a
                    href="https://apps.apple.com/us/app/holypills/id6752483362"
                    target="_blank"
                  >
                    <img src={iosButton} alt="ios-icon" />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.holypills"
                    target="_blank"
                  >
                    <img src={androidButton} alt="android-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
